const dsCoupon = (($) => {

    const modal_promo = 'div.promo-modal',
        promo_cancel = 'a#promo_button_cancel',
        promo_redeem = 'button.promo-code-redeem',
        promo_message = 'div.promo-modal-message',
        promo_close = 'button#promo_button_close',
        promo_input = 'input.modal-promo-input';
    let code_cancel = '';

    function promoModalOpen(code = '',) {
        code_cancel = code;
        $(modal_promo).removeClass('hide');
        $(promo_input).focus();
        if (code.length > 0) {
            $(`${modal_promo} input.coupon-input`).val(code);
            $(promo_cancel).html('Delete').attr('data-type', codeType(code));
        } else {
            $(promo_cancel).html('Cancel');
        }
    }

    function promoModalClose(el) {
        const type = $(el).attr('data-type');
        $(promo_input).val('');
        $(promo_message).html('');
        $(`${modal_promo}, ${promo_close}`).addClass('hide');
        $(`${promo_cancel}, ${promo_redeem}`).removeClass('hide');
        if ($(el).attr('id') === 'promo_button_cancel' && $(el).html() === 'Delete') {
            if ((type === 'coupon' && doorstep.coupon !== '') || type === 'voucher' && doorstep.voucher.includes(code_cancel)) {
                removeCoupon();
            }
        }
    }

    function removeCoupon() {
        if (code_cancel.length > 0) {
            const type = codeType(code_cancel);
            $.ajax({
                url : dsUtilities.urlCart() + '/remove_' + type,
                type : 'post',
                dataType : 'json',
                data : { code : code_cancel },
                success: function (response) {
                    if (response.success) {
                        if (type === 'coupon') {
                            doorstep.coupon = '';
                        } else {
                            doorstep.voucher = doorstep.voucher.filter(item => item !== code_cancel);
                        }
                        if (response.reload !== undefined && response.reload) {
                            window.location.reload();
                        } else {
                            dsCart.couponMessage(response.message, false);
                            dsCart.couponRemove(code_cancel);
                            code_cancel = '';
                        }
                    }
                }
            });
        }
    }

    function promoCodeRedeem(stage) {
        const coupon = $('.coupon-input').val().trim();
        if (codeType(coupon) === 'voucher') {
            redeemVoucher(coupon, stage);
        } else if (coupon.length > 0) {
            redeemCoupon(coupon, stage);
        }
    }

    function redeemCoupon(coupon, stage) {
        $.ajax({
            url: dsUtilities.urlCart() + '/coupon',
            type: 'post',
            data: { coupon: coupon, stage: stage },
            dataType: 'json',
            success: function (response) {
                if (response.error !== undefined) {
                    promoCodeMessage(response, stage, coupon, true);
                    if (!response.error) {
                        dsCart.writeCoupon('Coupon', response.code);
                    }
                }
            }
        });
    }

    function redeemVoucher(voucher, stage) {
        $.ajax({
            url: dsUtilities.urlCart() + '/voucher',
            type: 'post',
            data: { voucher: voucher, stage: stage },
            dataType: 'json',
            success: function (response) {
                if (response.error !== undefined) {
                    promoCodeMessage(response, stage, voucher, true);
                    if (!response.error) {
                        dsCart.writeCoupon('Voucher', voucher);
                    }
                }
            }
        });
    }

    function promoCodeMessage(response, stage, coupon, redeeming = false) {
        let message = '';
        if (response.error) {
            message += `<div class="error_colour">${response.message}</div>`;
        }
        if (!response.error) {
            if (codeType(coupon) === 'coupon') {
                doorstep.coupon = coupon;
            } else {
                doorstep.voucher.push(coupon);
            }
            $(`${promo_cancel}, ${promo_redeem}`).addClass('hide');
            $(promo_close).removeClass('hide');
            message += `<div class="success_colour">${response.message}</div>`;
            if (response.product !== undefined && response.product.length > 0) {
                setTimeout(function() {
                    window.location.reload();
                }, 1000);
            };
        }
        if (response.warning.length > 0) {
            message += '<div class="warning_colour">';
            response.warning.forEach(function (msg) {
                message += `${msg}<br>`;
            });
            message += '</div>';
        }
        if (stage === 'mybox') {
            if (response.cart_text === undefined && !redeeming) {
                dsCart.couponRemove(coupon, response.extra)
            }
            $(promo_message).html(message);
        }
    }

    function codeType(code) {
        return code.startsWith('GV') ? 'voucher' : 'coupon';
    }

    function couponCheck(stage = '', checks = []) {
        return $.ajax({
            url     : dsUtilities.urlCart() + '/coupon_check',
            type     : 'post',
            data     : { stage: stage, checks },
            dataType : 'json'
        });
    }

    $(document).ready(function () {

        $('.promo-modal-close').on('click', function (e) {
            e.preventDefault();
            promoModalClose(this);
        });

        $(promo_redeem).on('click', function() {
            promoCodeRedeem('mybox');
        });

    });

    return {
        promoModalOpen  : promoModalOpen,
        couponCheck     : couponCheck
    }

})(jQuery);